module.exports = __webpack_public_path__ + "static/media/lotto-zZGKj7RNxq64pAl8vycHl8OWiv3j4y.91c22bed.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lotto-zZGKj7RNxq64pAl8vycHl8OWiv3j4y.webp
// module id = 642
// module chunks = 0